import { Api } from '@axiom/ui';
import type {
  AccountIntake,
  Candidate,
  Contact,
  OpportunityIntakeCandidateResponse,
} from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';

export type opportunityIntakeResponseType = {
  submissionId: string;
};

export type CandidateContactOption = {
  submissionId: string;
  jobName: string;
};

class OpportunityIntakeApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiAltUrl,
    });
  }

  async createOpportunityIntake(body: Partial<AccountIntake>) {
    return super.write<{ data: opportunityIntakeResponseType }>({
      endpoint: `/intake/opportunity`,
      method: 'POST',
      body,
    });
  }

  async updateOpportunityIntake(body: Partial<AccountIntake>) {
    return super.write<{ data: opportunityIntakeResponseType }>({
      endpoint: `/intake/opportunity`,
      method: 'PUT',
      body,
    });
  }

  async createOpportunityIntakeWithCandidate(
    candidateId: Candidate['id'],
    body: Partial<AccountIntake>,
    submissionId?: string
  ) {
    const query = submissionId ? { submissionId } : {};
    return super.write<{ data: OpportunityIntakeCandidateResponse }>({
      endpoint: `/intake/opportunity/candidates/${candidateId}`,
      method: 'POST',
      query,
      body,
    });
  }

  readContactOpportunitiesForCandidate(
    candidateId: Candidate['id'],
    contactId: Contact['id']
  ) {
    return super.read<{ data: CandidateContactOption[] }>({
      endpoint: `/intake/opportunity/candidates/${candidateId}/contacts/${contactId}/options`,
      method: 'GET',
    });
  }

  async refreshContactOpportunitiesForCandidate(
    candidateId: Candidate['id'],
    contactId: Contact['id']
  ) {
    return super.invalidate(
      `/intake/opportunity/candidates/${candidateId}/contacts/${contactId}/options`
    );
  }
}

export const OpportunityIntakeApi = new OpportunityIntakeApiClass();
